import api from '../api';



export const crfSolicitacaoExecucaoRotinaRelatorioProjetoPacote = () => {
    return api.post('routinesCrfch/solicitacaoExecucaoRotinaRelatorioProjetoPacote');
}

export const crfAtualizarRelatorioADistribuirRelatorio = () => {
    return api.post('routinesCrfch/crfAtualizarRelatorioADistribuirRelatorio');
}
